export default "__VITE_ASSET__aS4FsvHK__"